/** @format */

import TableToExcel from "@linways/table-to-excel/dist/tableToExcel";
import jsPDF from "jspdf";
import JSZip from "jszip";
import saveAs from "file-saver";
import autoTable from "jspdf-autotable";

const RESERVOIR_TABLE_IDS = ["so1", "so2", "so3", "so4", "so5", "so6"];
const RAVOTXOJI_TABLE_ID = "ravotxojiTable";
const REKA02_TABLE_ID = "reka02Table";
const REKA02_EXPORT_NAME = "02 reyka va uchqurgon";
const OQJAR_TABLE_ID = "oqjarQizilqishloqTable";
const OQJAR_EXPORT_NAME = "Oqjar Qizilqishloq";
const RESERVOIR_COLUMN_WIDTHS = {
  so1: [6, 30, 13, 13, 13, 12, 13, 13, 13, 12, 12, 12, 12, 12, 12, 12],
  so2: [6, 30, 13, 14, 13, 13, 13, 13],
  so3: [6, 30, 13, 13, 13, 12, 13, 13, 12, 13, 13, 12, 14, 12],
  so4: [6, 30, 13, 13, 13, 13, 15, 12, 10, 12, 10, 13, 13, 12, 13, 13, 12],
  so5: [34, 12, 12, 12, 12, 12, 12, 12, 12, 12],
  so6: [28, 14, 12, ...Array(31).fill(8)],
};
const EXCEL_BORDER_COLOR = "FFD9E2F3";
const EXCEL_HEADER_BLUE = "FF2F5597";
const EXCEL_HEADER_DARK_BLUE = "FF1F4E79";
const EXCEL_GROUP_FILL = "FFEAF2F8";
const EXCEL_TOTAL_FILL = "FFF2F2F2";
const EXCEL_ALT_ROW_FILL = "FFF8FAFF";
const PDF_HEADER_BLUE = [47, 85, 151];
const PDF_HEADER_DARK_BLUE = [31, 78, 121];
const PDF_BORDER_BLUE = [217, 226, 243];
const PDF_GROUP_FILL = [234, 242, 248];
const PDF_TOTAL_FILL = [242, 242, 242];
const PDF_ALT_ROW_FILL = [248, 250, 255];

export const PrintElem = (selector = ".table") => {
  let mywindow = window.open("", "PRINT", "min-width=21cm");
  mywindow.document.write(
    '<link href="bootstrap.css" rel="stylesheet">\n' +
      '<link rel="stylesheet" href="index.css">'
  );
  mywindow.document.write(document.querySelector(selector).innerHTML);

  mywindow.focus();
  setTimeout(() => {
    mywindow.print();
    mywindow.document.close();
    mywindow.close();
  }, 2000);
};

// export const ExcelPrint = (name = "excel_name", sheet = "Sheet 1", id) => {
//   const table = document.getElementById(id);
//   const checkedRows = table.querySelectorAll("input[type='checkbox']:checked");
//   const newTable = document.createElement("table");

//   const thead = table.querySelector("thead");
//   if (thead) newTable.appendChild(thead.cloneNode(true));

//   if (checkedRows.length === 0) {
//     const tbody = table.querySelector("tbody");
//     if (tbody) newTable.appendChild(tbody.cloneNode(true));
//   } else {
//     checkedRows.forEach((checkbox) => {
//       const row = checkbox.closest("tr");
//       if (row) {
//         newTable.appendChild(row.cloneNode(true));
//       }
//     });
//   }

//   TableToExcel.convert(newTable, {
//     name: `${name}.xlsx`,
//     sheet: {
//       name: sheet,
//     },
//   });
// };

// export const Pdf = (id, isLandscape = true) => {
//     const doc = new jsPDF(isLandscape ? 'landscape' : null,'mm')
//     autoTable(doc, {
//         html: '#'+id,
//         tableWidth:"auto",
//         headStyles: {
//             minCellWidth: 10,
//         },
//         bodyStyles: {
//             cellWidth: 12
//         },
//         styles: {
//             valign: 'middle',
//             halign: 'center',
//             fontSize: 8,
//             lineColor: '#000',
//             lineWidth: 0.0001,
//             cellPadding: 1,
//             tableWidth: 100,
//             overflow: 'hidden'
//         },
//         columnStyles: { 0: { cellWidth: -1 }, 2: { cellWidth: 55, halign: 'left' }, 3: { cellWidth: -2 } },
//     })
//     doc.save('table.pdf')
//
// }

export const ExcelPrint = (
  name = "excel_name",
  sheet = "Sheet 1",
  id,
  exportDate = null
) => {
  const table = document.getElementById(id);
  if (!table) {
    return;
  }

  const checkedRows = table.querySelectorAll("input[type='checkbox']:checked");

  const newTable = document.createElement("table");

  // <thead> ni klon qilamiz
  const thead = table.querySelector("thead");
  if (thead) {
    newTable.appendChild(thead.cloneNode(true));
  }

  // <tbody> yaratamiz
  const newTbody = document.createElement("tbody");

  // Agar belgilanmagan bo‘lsa - barcha satrlarni olish
  if (checkedRows.length === 0) {
    const rows = table.querySelectorAll("tbody tr");
    rows.forEach((row) => {
      newTbody.appendChild(row.cloneNode(true));
    });
  } else {
    // Faqat belgilanganni olish
    checkedRows.forEach((checkbox) => {
      const row = checkbox.closest("tr");
      if (row) newTbody.appendChild(row.cloneNode(true));
    });
  }

  newTable.appendChild(newTbody);

  if (RESERVOIR_TABLE_IDS.includes(id)) {
    prepareReservoirExcelTable(newTable, id, exportDate);
  }

  if (id === RAVOTXOJI_TABLE_ID) {
    prepareRavotxojiExcelTable(
      newTable,
      table.getAttribute("data-excel-range") === "true"
    );
  }

  if (id === REKA02_TABLE_ID) {
    prepareReka02ExcelTable(newTable);
  }

  if (id === OQJAR_TABLE_ID) {
    prepareOqjarExcelTable(newTable);
  }

  if (
    [RAVOTXOJI_TABLE_ID, REKA02_TABLE_ID, OQJAR_TABLE_ID].includes(id) &&
    table.getAttribute("data-excel-range") === "true"
  ) {
    if (id !== RAVOTXOJI_TABLE_ID) prepareAdditionalRangeExcelTable(newTable, id);
    const workbook = TableToExcel.tableToBook(newTable, {
      autoStyle: false,
      sheet: { name: sheet },
    });
    // TableToExcel truncates fractional column widths while parsing the table.
    const worksheet = workbook.worksheets[0];
    worksheet.pageSetup = {
      ...worksheet.pageSetup,
      paperSize: 9,
      orientation: "landscape",
      fitToPage: true,
      fitToWidth: 1,
      fitToHeight: 1,
      horizontalCentered: true,
      verticalCentered: false,
      margins: {
        left: 0.55,
        right: 0.5,
        top: 0.55,
        bottom: 0.55,
        header: 0,
        footer: 0,
      },
      printArea: `A1:${worksheet.getRow(worksheet.rowCount).getCell(worksheet.columnCount).address}`,
    };
    newTable.getAttribute("data-cols-width").split(",").forEach((width, index) => {
      worksheet.getColumn(index + 1).width = Number(width);
    });
    saveRavotxojiRangeExcel(workbook, `${name}.xlsx`);
    return;
  }

  TableToExcel.convert(newTable, {
    name: `${name}.xlsx`,
    sheet: {
      name: sheet,
    },
  });
};

const saveRavotxojiRangeExcel = async (workbook, name) => {
  const zip = await JSZip.loadAsync(await workbook.xlsx.writeBuffer());
  const sheetPath = "xl/worksheets/sheet1.xml";
  const sheetXml = await zip.file(sheetPath).async("string");
  // Excel requires printOptions before pageMargins; the bundled writer reverses them.
  const centeredSheetXml = sheetXml
    .replace(/<printOptions\b[^>]*\/>/g, "")
    .replace("<pageMargins", '<printOptions horizontalCentered="1"/><pageMargins');
  zip.file(sheetPath, centeredSheetXml);
  const buffer = await zip.generateAsync({ type: "arraybuffer" });
  saveAs(
    new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    }),
    name
  );
};

const prepareRavotxojiExcelTable = (table, isRange = false) => {
  const totalColumns = getMaxColumnCount(table);
  const widths = [
    isRange ? 8.6640625 : 11,
    isRange ? 13.6640625 : 16,
    ...Array(Math.max(totalColumns - 2, 0)).fill(isRange ? 9.5546875 : 12),
  ];

  table.setAttribute("data-cols-width", widths.join(","));

  const rows = Array.from(table.querySelectorAll("tr"));
  rows.forEach((row, index) => {
    const cells = Array.from(row.children);
    const isHeadRow = row.parentElement?.tagName?.toLowerCase() === "thead";
    const isTitleRow = row.classList.contains("ravotxoji-title-row");
    const isAverageRow = row.classList.contains("ravotxoji-average-row");

    row.setAttribute(
      "data-height",
      isRange
        ? isTitleRow ? "33.6" : "26.6"
        : isTitleRow ? "30" : isHeadRow ? "27" : isAverageRow ? "24" : "22"
    );

    cells.forEach((cell) => {
      applyExcelCellBase(cell);

      if (isRange) {
        cell.setAttribute("data-f-name", "Times New Roman");
        cell.removeAttribute("data-fill-color");
        applyExcelCellStyle(cell, {
          fill: isHeadRow ? EXCEL_GROUP_FILL : isAverageRow ? "FFC4BD97" : undefined,
          color: "FF000000",
          size: isTitleRow ? "15" : "11",
          bold:
            isHeadRow ||
            isAverageRow ||
            row.classList.contains("tr1") ||
            cell.classList.contains("ravotxoji-source-cell"),
          borderStyle: "thin",
          borderColor: "FF000000",
        });
        if (!isHeadRow) {
          setExcelNumberType(cell);
        }
        return;
      }

      if (isTitleRow) {
        applyExcelCellStyle(cell, {
          fill: EXCEL_HEADER_DARK_BLUE,
          color: "FFFFFFFF",
          bold: true,
          size: "13",
          horizontal: "center",
          vertical: "middle",
          wrap: true,
          borderStyle: "medium",
          borderColor: "FFFFFFFF",
        });
        return;
      }

      if (isHeadRow) {
        applyExcelCellStyle(cell, {
          fill: EXCEL_HEADER_BLUE,
          color: "FFFFFFFF",
          bold: true,
          size: "11",
          horizontal: "center",
          vertical: "middle",
          borderStyle: "thin",
          borderColor: "FFFFFFFF",
        });
        return;
      }

      if (isAverageRow) {
        applyExcelCellStyle(cell, {
          fill: EXCEL_TOTAL_FILL,
          color: "FF000000",
          bold: true,
          horizontal: "center",
          vertical: "middle",
          wrap: true,
        });
        setExcelNumberType(cell);
        return;
      }

      if (index % 2 === 0) {
        cell.setAttribute("data-fill-color", EXCEL_ALT_ROW_FILL);
      }

      setExcelNumberType(cell);
    });
  });
};

const prepareReka02ExcelTable = (table) => {
  const totalColumns = getMaxColumnCount(table);
  const widths = [
    13,
    24,
    ...Array(Math.max(totalColumns - 3, 0)).fill(9),
    12,
  ];

  table.setAttribute("data-cols-width", widths.join(","));

  const rows = Array.from(table.querySelectorAll("tr"));
  rows.forEach((row, index) => {
    const cells = Array.from(row.children);
    const isHeadRow = row.parentElement?.tagName?.toLowerCase() === "thead";
    const isTitleRow = row.classList.contains("reka02-title-row");
    const isDataRow =
      row.classList.contains("reka02-main-row") ||
      row.classList.contains("reka02-sub-row");

    row.setAttribute("data-height", isTitleRow ? "30" : isHeadRow ? "27" : "22");

    cells.forEach((cell, cellIndex) => {
      applyExcelCellBase(cell);

      if (isTitleRow) {
        applyExcelCellStyle(cell, {
          fill: EXCEL_HEADER_DARK_BLUE,
          color: "FFFFFFFF",
          bold: true,
          size: "13",
          horizontal: "center",
          vertical: "middle",
          wrap: true,
          borderStyle: "medium",
          borderColor: "FFFFFFFF",
        });
        return;
      }

      if (isHeadRow) {
        applyExcelCellStyle(cell, {
          fill: EXCEL_HEADER_BLUE,
          color: "FFFFFFFF",
          bold: true,
          size: "11",
          horizontal: "center",
          vertical: "middle",
          wrap: false,
          borderStyle: "thin",
          borderColor: "FFFFFFFF",
        });
        return;
      }

      if (isDataRow && index % 2 === 0) {
        cell.setAttribute("data-fill-color", EXCEL_ALT_ROW_FILL);
      }

      if (cellIndex === cells.length - 1) {
        applyExcelCellStyle(cell, {
          fill: EXCEL_TOTAL_FILL,
          bold: true,
          horizontal: "center",
          vertical: "middle",
          wrap: true,
        });
      }

      setExcelNumberType(cell);
    });
  });
};

const prepareOqjarExcelTable = (table) => {
  const widths = [15, 12, 16, 13, 13, 24, 11, 11, 13, 12, 17, 14, 14];
  table.setAttribute("data-cols-width", widths.join(","));

  const rows = Array.from(table.querySelectorAll("tr"));
  rows.forEach((row, index) => {
    const cells = Array.from(row.children);
    const isHeadRow = row.parentElement?.tagName?.toLowerCase() === "thead";
    const isTitleRow = row.classList.contains("oqjar-title-row");
    const isDataRow =
      row.classList.contains("oqjar-main-row") ||
      row.classList.contains("oqjar-sub-row");

    row.setAttribute("data-height", isTitleRow ? "32" : isHeadRow ? "30" : "22");

    cells.forEach((cell) => {
      applyExcelCellBase(cell);

      if (isTitleRow) {
        applyExcelCellStyle(cell, {
          fill: EXCEL_HEADER_DARK_BLUE,
          color: "FFFFFFFF",
          bold: true,
          size: "13",
          horizontal: "center",
          vertical: "middle",
          wrap: true,
          borderStyle: "medium",
          borderColor: "FFFFFFFF",
        });
        return;
      }

      if (isHeadRow) {
        applyExcelCellStyle(cell, {
          fill: EXCEL_HEADER_BLUE,
          color: "FFFFFFFF",
          bold: true,
          size: "11",
          horizontal: "center",
          vertical: "middle",
          wrap: true,
          borderStyle: "thin",
          borderColor: "FFFFFFFF",
        });
        return;
      }

      if (isDataRow && index % 2 === 0) {
        cell.setAttribute("data-fill-color", EXCEL_ALT_ROW_FILL);
      }

      setExcelNumberType(cell);
    });
  });
};

const prepareAdditionalRangeExcelTable = (table, id) => {
  const isReka = id === REKA02_TABLE_ID;
  // Preserve each table's column proportions and merged-cell structure.
  if (isReka) prepareReka02ExcelTable(table);
  else prepareOqjarExcelTable(table);
  Array.from(table.querySelectorAll("tr")).forEach((row, index) => {
    const isHead = row.parentElement.tagName.toLowerCase() === "thead";
    const isTitle = isHead && index === 0;
    const isMain = row.classList.contains(isReka ? "reka02-main-row" : "oqjar-main-row");
    row.setAttribute("data-height", isTitle ? "33.6" : "26.6");
    Array.from(row.children).forEach((cell, cellIndex) => {
      applyExcelCellBase(cell);
      cell.setAttribute("data-f-name", "Times New Roman");
      cell.removeAttribute("data-fill-color");
      cell.removeAttribute("data-f-bold");
      const isAverage = isReka && !isHead && cellIndex === row.children.length - 1;
      applyExcelCellStyle(cell, {
        fill: isHead ? EXCEL_GROUP_FILL : isAverage ? "FFC4BD97" : undefined,
        color: "FF000000",
        size: isTitle ? "15" : "11",
        bold: isHead || isMain || isAverage || (isReka && cellIndex === 0),
        borderStyle: "thin",
        borderColor: "FF000000",
      });
      if (!isHead) setExcelNumberType(cell);
    });
  });
  const totalHeight = Array.from(table.querySelectorAll("tr"))
    .reduce((sum, row) => sum + Number(row.getAttribute("data-height")), 0);
  const columnPixels = table.getAttribute("data-cols-width").split(",")
    .map((width) => Number(width) * 7 + 5);
  const totalPixels = columnPixels.reduce((sum, width) => sum + width, 0);
  const pageRatio = (297 - 1.05 * 25.4) / (210 - 1.1 * 25.4);
  const targetPixels = totalHeight * 96 / 72 * pageRatio;
  table.setAttribute("data-cols-width", columnPixels
    .map((width) => Math.max(1, (width * targetPixels / totalPixels - 5) / 7))
    .join(","));
};

const prepareReservoirExcelTable = (table, id, exportDate) => {
  const widths = getReservoirColumnWidths(id, table);
  if (widths) {
    table.setAttribute("data-cols-width", widths.join(","));
  }

  const totalColumns = widths?.length || getMaxColumnCount(table);
  addReservoirExcelDateRow(table, exportDate, totalColumns);
  fillShortReservoirRows(table, totalColumns);

  const rows = Array.from(table.querySelectorAll("tr"));
  rows.forEach((row, index) => {
    const cells = Array.from(row.children);
    const isHeadRow = row.parentElement?.tagName?.toLowerCase() === "thead";
    const isTitleRow = isHeadRow && index === 0;
    const isDateRow = row.classList.contains("reservoir-excel-date-row");
    const isGroupRow = row.classList.contains("table-one-row");
    const isSummaryRow =
      row.classList.contains("j-tr") && !row.classList.contains("table-one-row");
    const isDataRow = row.classList.contains("data-tr");

    row.setAttribute(
      "data-height",
      isTitleRow ? "30" : isDateRow ? "24" : isHeadRow ? "28" : isGroupRow ? "24" : "22"
    );

    cells.forEach((cell, cellIndex) => {
      applyExcelCellBase(cell);

      if (isTitleRow) {
        applyExcelCellStyle(cell, {
          fill: EXCEL_HEADER_DARK_BLUE,
          color: "FFFFFFFF",
          bold: true,
          size: "13",
          horizontal: "center",
          vertical: "middle",
          wrap: true,
          borderStyle: "medium",
          borderColor: "FFFFFFFF",
        });
        return;
      }

      if (isDateRow) {
        applyExcelCellStyle(cell, {
          fill: "FFFFFFFF",
          color: "FF000000",
          bold: true,
          size: "12",
          horizontal: "right",
          vertical: "middle",
          wrap: true,
        });
        return;
      }

      if (isHeadRow) {
        applyExcelCellStyle(cell, {
          fill: EXCEL_HEADER_BLUE,
          color: "FFFFFFFF",
          bold: true,
          size: "11",
          horizontal: "center",
          vertical: "middle",
          wrap: true,
          borderStyle: "thin",
          borderColor: "FFFFFFFF",
        });
        return;
      }

      if (isGroupRow) {
        applyExcelCellStyle(cell, {
          fill: EXCEL_GROUP_FILL,
          color: "FF1F4E79",
          bold: true,
          size: "11",
          horizontal: "center",
          vertical: "middle",
          wrap: true,
        });
        return;
      }

      if (isSummaryRow) {
        applyExcelCellStyle(cell, {
          fill: EXCEL_TOTAL_FILL,
          color: "FF000000",
          bold: true,
          horizontal: cellIndex === 0 ? "center" : "center",
          vertical: "middle",
          wrap: true,
        });
        setExcelNumberType(cell);
        return;
      }

      if (isDataRow && index % 2 === 0) {
        cell.setAttribute("data-fill-color", EXCEL_ALT_ROW_FILL);
      }

      if (
        ((id === "so5" || id === "so6") && cell.classList.contains("fix-with")) ||
        (id !== "so5" && id !== "so6" && cellIndex === 1)
      ) {
        cell.setAttribute("data-a-h", "left");
        cell.setAttribute("data-a-wrap", "true");
      }

      setExcelNumberType(cell);
    });
  });
};

const addReservoirExcelDateRow = (table, exportDate, totalColumns) => {
  if (!exportDate) {
    return;
  }

  const thead = table.querySelector("thead");
  const titleRow = thead?.querySelector("tr");
  if (!thead || !titleRow) {
    return;
  }

  const row = document.createElement("tr");
  row.className = "reservoir-excel-date-row";

  const cell = document.createElement("th");
  cell.colSpan = totalColumns;
  cell.textContent = `Sana: ${formatExcelExportDate(exportDate)}`;
  row.appendChild(cell);

  titleRow.after(row);
};

const fillShortReservoirRows = (table, totalColumns) => {
  const rows = Array.from(table.querySelectorAll("tbody tr"));

  rows.forEach((row) => {
    if (!isReservoirDividerRow(row)) {
      return;
    }

    const currentColumns = getRowColumnCount(row);
    for (let i = currentColumns; i < totalColumns; i += 1) {
      row.appendChild(document.createElement("td"));
    }
  });
};

const isReservoirDividerRow = (row) => {
  const text = String(row.textContent || "").trim().toLowerCase();

  return row.classList.contains("j-tr") && text === "shu jumladan";
};

const getMaxColumnCount = (table) => {
  return Array.from(table.querySelectorAll("tr")).reduce((max, row) => {
    return Math.max(max, getRowColumnCount(row));
  }, 0);
};

const getRowColumnCount = (row) => {
  return Array.from(row.children).reduce((total, cell) => {
    return total + (parseInt(cell.getAttribute("colspan"), 10) || 1);
  }, 0);
};

const getReservoirColumnWidths = (id, table) => {
  const widths = RESERVOIR_COLUMN_WIDTHS[id];

  if (!widths) {
    return null;
  }

  if (id === "so6") {
    return widths.slice(0, getMaxColumnCount(table));
  }

  return widths;
};

const formatExcelExportDate = (value) => {
  const date = String(value || "");
  const match = date.match(/^(\d{4})-(\d{2})-(\d{2})/);

  if (!match) {
    return date;
  }

  return `${match[3]}.${match[2]}.${match[1]}`;
};

const applyExcelCellBase = (cell) => {
  cell.setAttribute("data-a-h", "center");
  cell.setAttribute("data-a-v", "middle");
  cell.setAttribute("data-a-wrap", "true");
  cell.setAttribute("data-f-name", "Arial");
  cell.setAttribute("data-f-sz", "10");
  cell.setAttribute("data-b-a-s", "thin");
  cell.setAttribute("data-b-a-c", EXCEL_BORDER_COLOR);
};

const applyExcelCellStyle = (
  cell,
  {
    fill,
    color,
    bold,
    size,
    horizontal,
    vertical,
    wrap,
    borderStyle,
    borderColor,
  }
) => {
  if (fill) {
    cell.setAttribute("data-fill-color", fill);
  }

  if (color) {
    cell.setAttribute("data-f-color", color);
  }

  if (bold) {
    cell.setAttribute("data-f-bold", "true");
  }

  if (size) {
    cell.setAttribute("data-f-sz", size);
  }

  if (horizontal) {
    cell.setAttribute("data-a-h", horizontal);
  }

  if (vertical) {
    cell.setAttribute("data-a-v", vertical);
  }

  if (wrap) {
    cell.setAttribute("data-a-wrap", "true");
  }

  if (borderStyle) {
    cell.setAttribute("data-b-a-s", borderStyle);
  }

  if (borderColor) {
    cell.setAttribute("data-b-a-c", borderColor);
  }
};

const setExcelNumberType = (cell) => {
  const value = getCellText(cell);

  if (!/^-?\d+(\.\d+)?$/.test(value)) {
    return;
  }

  cell.setAttribute("data-t", "n");
};

const getCellText = (cell) => {
  return String(cell.textContent || "")
    .replace(/\s+/g, " ")
    .trim()
    .replace(",", ".");
};

export const Pdf = (id, isLandscape = true, exportDate = null) => {
  if (RESERVOIR_TABLE_IDS.includes(id)) {
    exportReservoirPdf(id, isLandscape, exportDate);
    return;
  }

  if (id === RAVOTXOJI_TABLE_ID) {
    exportRavotxojiPdf(isLandscape);
    return;
  }

  if (id === REKA02_TABLE_ID) {
    exportReka02Pdf(isLandscape);
    return;
  }

  if (id === OQJAR_TABLE_ID) {
    exportOqjarPdf(isLandscape);
    return;
  }

  const doc = new jsPDF(isLandscape ? "landscape" : null, "mm");
  autoTable(doc, {
    html: "#" + id,
    tableWidth: "auto",
    headStyles: {
      minCellWidth: 10,
    },
    columns: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14],
    bodyStyles: {
      cellWidth: 12,
    },
    styles: {
      valign: "middle",
      halign: "center",
      fontSize: 8,
      lineColor: "#000",
      lineWidth: 0.0001,
      cellPadding: 1,
      tableWidth: 100,
      overflow: "hidden",
    },
    columnStyles: {
      0: { cellWidth: -1 },
      2: { cellWidth: 55, halign: "left" },
      3: { cellWidth: -2 },
    },
  });
  doc.save("table.pdf");
};

const exportRavotxojiPdf = (isLandscape) => {
  const sourceTable = document.getElementById(RAVOTXOJI_TABLE_ID);
  if (!sourceTable) {
    return;
  }

  if (sourceTable.getAttribute("data-excel-range") === "true") {
    return exportRavotxojiRangePdf(sourceTable);
  }

  const doc = new jsPDF(isLandscape ? "landscape" : "portrait", "mm", "a4");
  const pageWidth = doc.internal.pageSize.getWidth();
  const contentWidth = pageWidth - 8;
  const tableData = getRavotxojiPdfTableData(sourceTable);

  autoTable(doc, {
    head: tableData.head,
    body: tableData.body,
    theme: "grid",
    tableWidth: contentWidth,
    margin: { top: 5, right: 4, bottom: 7, left: 4 },
    styles: {
      font: "helvetica",
      fontSize: 4.4,
      cellPadding: 0.55,
      overflow: "visible",
      valign: "middle",
      halign: "center",
      lineColor: PDF_BORDER_BLUE,
      lineWidth: 0.08,
      textColor: [0, 0, 0],
    },
    headStyles: {
      fillColor: PDF_HEADER_BLUE,
      textColor: [255, 255, 255],
      fontStyle: "bold",
      halign: "center",
      valign: "middle",
      lineColor: [255, 255, 255],
      lineWidth: 0.1,
      cellPadding: 0.65,
    },
    bodyStyles: {
      fillColor: [255, 255, 255],
    },
    alternateRowStyles: {
      fillColor: PDF_ALT_ROW_FILL,
    },
    columnStyles: getRavotxojiPdfColumnStyles(tableData.totalColumns, contentWidth),
    didParseCell: (data) => {
      styleRavotxojiPdfCell(data);
    },
  });

  doc.save("Ravotxoji.pdf");
};

const exportRavotxojiRangePdf = async (sourceTable, name = "Ravotxoji") => {
  const table = sourceTable.cloneNode(true);
  const isAdditionalRange = sourceTable.id !== RAVOTXOJI_TABLE_ID;
  if (isAdditionalRange) prepareAdditionalRangeExcelTable(table, sourceTable.id);
  else prepareRavotxojiExcelTable(table, true);
  const doc = new jsPDF("landscape", "mm", "a4");
  const fonts = await Promise.all(["times.ttf", "timesbd.ttf"].map(async (name) => {
    const response = await fetch(`${process.env.PUBLIC_URL || ""}/fonts/${name}`);
    if (!response.ok) throw new Error(`PDF font could not be loaded: ${name}`);
    const bytes = new Uint8Array(await response.arrayBuffer());
    let binary = "";
    for (let offset = 0; offset < bytes.length; offset += 8192) {
      binary += String.fromCharCode(...bytes.subarray(offset, offset + 8192));
    }
    return btoa(binary);
  }));
  ["normal", "bold"].forEach((style, index) => {
    const name = index === 0 ? "times.ttf" : "timesbd.ttf";
    doc.addFileToVFS(name, fonts[index]);
    doc.addFont(name, "Times New Roman", style);
  });

  // Match Excel's column units, row points and A4 print scaling.
  const widths = table.getAttribute("data-cols-width").split(",")
    .map((width) => (Number(width) * 7 + 5) * 25.4 / 96);
  if (name === REKA02_EXPORT_NAME && widths.length > 0) {
    widths[widths.length - 1] *= 1.2;
  }
  const rows = Array.from(table.querySelectorAll("tr"));
  const heights = rows.map((row) => Number(row.getAttribute("data-height")) * 25.4 / 72);
  const totalWidth = widths.reduce((sum, width) => sum + width, 0);
  const totalHeight = heights.reduce((sum, height) => sum + height, 0);
  const availableWidth = doc.internal.pageSize.getWidth() - (0.55 + 0.5) * 25.4;
  const availableHeight = doc.internal.pageSize.getHeight() - 1.1 * 25.4;
  const scale = Math.min(1, availableWidth / totalWidth, availableHeight / totalHeight);
  const widthScale = Math.min(scale * 1.21275, availableWidth / totalWidth);
  const left = 0.55 * 25.4 + (availableWidth - totalWidth * widthScale) / 2;
  const occupied = rows.map(() => []);
  let y = 0.55 * 25.4;
  doc.setDrawColor(0, 0, 0);
  doc.setTextColor(0, 0, 0);
  doc.setLineWidth(0.2 * scale);
  rows.forEach((row, rowIndex) => {
    let column = 0;
    Array.from(row.children).forEach((cell) => {
      while (occupied[rowIndex][column]) column += 1;
      const colSpan = cell.colSpan || 1;
      const rowSpan = cell.rowSpan || 1;
      const x = left + widths.slice(0, column).reduce((sum, width) => sum + width, 0) * widthScale;
      const width = widths.slice(column, column + colSpan).reduce((sum, value) => sum + value, 0) * widthScale;
      const height = heights.slice(rowIndex, rowIndex + rowSpan).reduce((sum, value) => sum + value, 0) * scale;
      for (let r = rowIndex; r < rowIndex + rowSpan; r += 1) {
        for (let c = column; c < column + colSpan; c += 1) occupied[r][c] = true;
      }
      const fill = cell.getAttribute("data-fill-color");
      doc.setFillColor(fill ? `#${fill.slice(-6)}` : "#FFFFFF");
      doc.rect(x, y, width, height, "FD");
      doc.setFont("Times New Roman", cell.getAttribute("data-f-bold") === "true" ? "bold" : "normal");
      const rangeFontSize = Number(cell.getAttribute("data-f-sz")) * scale;
      const rangeFontIncrease = name === OQJAR_EXPORT_NAME
        ? 3
        : [REKA02_EXPORT_NAME, "Ravotxoji"].includes(name) ? 2 : 0;
      doc.setFontSize(rangeFontSize + rangeFontIncrease);
      const text = isAdditionalRange
        ? doc.splitTextToSize(getCleanCellText(cell), Math.max(width - 1, 1))
        : getCleanCellText(cell);
      const lineHeight = doc.getFontSize() * 25.4 / 72 * 1.15;
      const textY = y + height / 2 - (Array.isArray(text) ? (text.length - 1) * lineHeight / 2 : 0);
      doc.text(text, x + width / 2, textY, {
        align: "center",
        baseline: "middle",
      });
      column += colSpan;
    });
    y += heights[rowIndex] * scale;
  });
  doc.save(`${name}.pdf`);
};

const exportReka02Pdf = (isLandscape) => {
  const sourceTable = document.getElementById(REKA02_TABLE_ID);
  if (!sourceTable) {
    return;
  }

  if (sourceTable.getAttribute("data-excel-range") === "true") {
    return exportRavotxojiRangePdf(sourceTable, REKA02_EXPORT_NAME);
  }

  const doc = new jsPDF(isLandscape ? "landscape" : "portrait", "mm", "a4");
  const pageWidth = doc.internal.pageSize.getWidth();
  const contentWidth = pageWidth - 8;
  const tableData = getReka02PdfTableData(sourceTable);

  autoTable(doc, {
    head: tableData.head,
    body: tableData.body,
    theme: "grid",
    tableWidth: contentWidth,
    margin: { top: 5, right: 4, bottom: 7, left: 4 },
    styles: {
      font: "helvetica",
      fontSize: 4.4,
      cellPadding: 0.55,
      overflow: "visible",
      valign: "middle",
      halign: "center",
      lineColor: PDF_BORDER_BLUE,
      lineWidth: 0.08,
      textColor: [0, 0, 0],
    },
    headStyles: {
      fillColor: PDF_HEADER_BLUE,
      textColor: [255, 255, 255],
      fontStyle: "bold",
      halign: "center",
      valign: "middle",
      lineColor: [255, 255, 255],
      lineWidth: 0.1,
      cellPadding: 0.65,
    },
    bodyStyles: {
      fillColor: [255, 255, 255],
    },
    alternateRowStyles: {
      fillColor: PDF_ALT_ROW_FILL,
    },
    columnStyles: getReka02PdfColumnStyles(tableData.totalColumns, contentWidth),
    didParseCell: (data) => {
      styleReka02PdfCell(data);
    },
  });

  doc.save(`${REKA02_EXPORT_NAME}.pdf`);
};

const exportOqjarPdf = (isLandscape) => {
  const sourceTable = document.getElementById(OQJAR_TABLE_ID);
  if (!sourceTable) {
    return;
  }

  if (sourceTable.getAttribute("data-excel-range") === "true") {
    return exportRavotxojiRangePdf(sourceTable, OQJAR_EXPORT_NAME);
  }

  const doc = new jsPDF(isLandscape ? "landscape" : "portrait", "mm", "a4");
  const pageWidth = doc.internal.pageSize.getWidth();
  const contentWidth = pageWidth - 10;
  const tableData = getOqjarPdfTableData(sourceTable);

  autoTable(doc, {
    head: tableData.head,
    body: tableData.body,
    theme: "grid",
    tableWidth: contentWidth,
    margin: { top: 5, right: 5, bottom: 7, left: 5 },
    styles: {
      font: "helvetica",
      fontSize: 5.3,
      cellPadding: 0.7,
      overflow: "linebreak",
      valign: "middle",
      halign: "center",
      lineColor: PDF_BORDER_BLUE,
      lineWidth: 0.08,
      textColor: [0, 0, 0],
    },
    headStyles: {
      fillColor: PDF_HEADER_BLUE,
      textColor: [255, 255, 255],
      fontStyle: "bold",
      halign: "center",
      valign: "middle",
      lineColor: [255, 255, 255],
      lineWidth: 0.1,
      cellPadding: 0.7,
    },
    bodyStyles: {
      fillColor: [255, 255, 255],
    },
    alternateRowStyles: {
      fillColor: PDF_ALT_ROW_FILL,
    },
    columnStyles: getOqjarPdfColumnStyles(contentWidth),
    didParseCell: (data) => {
      styleOqjarPdfCell(data);
    },
  });

  doc.save(`${OQJAR_EXPORT_NAME}.pdf`);
};

const exportReservoirPdf = (id, isLandscape, exportDate) => {
  const sourceTable = document.getElementById(id);
  if (!sourceTable) {
    return;
  }

  const table = sourceTable.cloneNode(true);
  const widths = getReservoirColumnWidths(id, table) || [];
  const totalColumns = widths.length || getMaxColumnCount(table);
  addReservoirExcelDateRow(table, exportDate, totalColumns);
  fillShortReservoirRows(table, totalColumns);

  const doc = new jsPDF(isLandscape ? "landscape" : "portrait", "mm", "a4");
  const pageWidth = doc.internal.pageSize.getWidth();
  const contentWidth = pageWidth - 12;
  const columnStyles = getReservoirPdfColumnStyles(widths, contentWidth, id);
  const fontSize = getReservoirPdfFontSize(id);

  autoTable(doc, {
    html: table,
    theme: "grid",
    tableWidth: "auto",
    margin: { top: 6, right: 6, bottom: 8, left: 6 },
    styles: {
      font: "helvetica",
      fontSize,
      cellPadding: 0.8,
      overflow: "linebreak",
      valign: "middle",
      halign: "center",
      lineColor: PDF_BORDER_BLUE,
      lineWidth: 0.1,
      textColor: [0, 0, 0],
    },
    headStyles: {
      fillColor: PDF_HEADER_BLUE,
      textColor: [255, 255, 255],
      fontStyle: "bold",
      halign: "center",
      valign: "middle",
      lineColor: [255, 255, 255],
      lineWidth: 0.12,
    },
    bodyStyles: {
      fillColor: [255, 255, 255],
    },
    alternateRowStyles: {
      fillColor: PDF_ALT_ROW_FILL,
    },
    columnStyles,
    didParseCell: (data) => {
      styleReservoirPdfCell(data, id);
    },
  });

  doc.save(`${id}.pdf`);
};

const getRavotxojiPdfTableData = (table) => {
  const titleText = getCleanCellText(
    table.querySelector(".ravotxoji-title-row th")
  );
  const headerCells = Array.from(table.querySelectorAll("thead tr:last-child th"));
  const headers = headerCells.map((cell) => getCleanCellText(cell));
  const totalColumns = headers.length;

  const head = [
    [
      {
        content: titleText,
        colSpan: totalColumns,
        styles: {
          fillColor: PDF_HEADER_DARK_BLUE,
          textColor: [255, 255, 255],
          fontStyle: "bold",
          fontSize: 6,
          halign: "center",
          valign: "middle",
        },
      },
    ],
    headers,
  ];

  const body = Array.from(table.querySelectorAll("tbody tr")).map((row) => {
    const cells = Array.from(row.children).map((cell) => getCleanCellText(cell));

    if (row.classList.contains("tr1")) {
      return [
        { content: cells[0], rowSpan: 2 },
        ...cells.slice(1),
      ];
    }

    if (row.classList.contains("ravotxoji-average-row")) {
      return [
        { content: cells[0], colSpan: 2 },
        ...cells.slice(1),
      ];
    }

    return cells;
  });

  return { head, body, totalColumns };
};

const getReka02PdfTableData = (table) => {
  const titleText = getCleanCellText(table.querySelector(".reka02-title-row th"));
  const headerCells = Array.from(table.querySelectorAll("thead tr:last-child th"));
  const headers = headerCells.map((cell) => getCleanCellText(cell));
  const totalColumns = headers.length;

  const head = [
    [
      {
        content: titleText,
        colSpan: totalColumns,
        styles: {
          fillColor: PDF_HEADER_DARK_BLUE,
          textColor: [255, 255, 255],
          fontStyle: "bold",
          fontSize: 6,
          halign: "center",
          valign: "middle",
        },
      },
    ],
    headers,
  ];

  const body = Array.from(table.querySelectorAll("tbody tr")).map((row) => {
    const cells = Array.from(row.children).map((cell) => getCleanCellText(cell));

    if (row.classList.contains("reka02-main-row")) {
      return [{ content: cells[0], rowSpan: 2 }, ...cells.slice(1)];
    }

    return cells;
  });

  return { head, body, totalColumns };
};

const getOqjarPdfTableData = (table) => {
  const titleText = getCleanCellText(table.querySelector(".oqjar-title-row th"));
  const headerRows = Array.from(table.querySelectorAll("thead tr")).slice(1);
  const totalColumns = getMaxColumnCount(table);

  const head = [
    [
      {
        content: titleText,
        colSpan: totalColumns,
        styles: {
          fillColor: PDF_HEADER_DARK_BLUE,
          textColor: [255, 255, 255],
          fontStyle: "bold",
          fontSize: 7,
          halign: "center",
          valign: "middle",
        },
      },
    ],
    ...headerRows.map((row) => getPdfCellsFromRow(row, normalizeOqjarPdfText)),
  ];

  const body = Array.from(table.querySelectorAll("tbody tr")).map((row) => {
    const cells = Array.from(row.children).map((cell) => getCleanCellText(cell));

    if (row.classList.contains("oqjar-main-row")) {
      return [
        { content: cells[0], rowSpan: 2 },
        cells[1],
        cells[2],
        { content: cells[3], rowSpan: 2 },
        { content: cells[4], rowSpan: 2 },
        ...cells.slice(5),
      ];
    }

    return cells;
  });

  return { head, body, totalColumns };
};

const getPdfCellsFromRow = (row, normalizeText = (text) => text) => {
  return Array.from(row.children).map((cell) => {
    const rowSpan = parseInt(cell.getAttribute("rowspan"), 10) || 1;
    const colSpan = parseInt(cell.getAttribute("colspan"), 10) || 1;
    const content = normalizeText(getCleanCellText(cell));

    if (rowSpan === 1 && colSpan === 1) {
      return content;
    }

    return {
      content,
      rowSpan,
      colSpan,
    };
  });
};

const normalizeOqjarPdfText = (text) => {
  return text
    .replace("Reyka №1 (sm)", "Reyka N1\n(sm)")
    .replace("Reyka №5 (sm)", "Reyka N5\n(sm)");
};

const getRavotxojiPdfColumnStyles = (totalColumns, contentWidth) => {
  const dayColumnWidth = (contentWidth - 28) / Math.max(totalColumns - 2, 1);
  const widths = [
    10,
    18,
    ...Array(Math.max(totalColumns - 2, 0)).fill(dayColumnWidth),
  ];

  return widths.reduce((styles, width, index) => {
    styles[index] = {
      cellWidth: width,
      halign: "center",
    };

    return styles;
  }, {});
};

const getReka02PdfColumnStyles = (totalColumns, contentWidth) => {
  const hourColumnWidth =
    (contentWidth - 14 - 28 - 13) / Math.max(totalColumns - 3, 1);
  const widths = [
    14,
    28,
    ...Array(Math.max(totalColumns - 3, 0)).fill(hourColumnWidth),
    13,
  ];

  return widths.reduce((styles, width, index) => {
    styles[index] = {
      cellWidth: width,
      halign: "center",
    };

    return styles;
  }, {});
};

const getOqjarPdfColumnStyles = (contentWidth) => {
  const widths = [15, 12, 18, 16, 16, 24, 11, 11, 13, 12, 16, 14, 14];
  const widthSum = widths.reduce((sum, width) => sum + width, 0);

  return widths.reduce((styles, width, index) => {
    styles[index] = {
      cellWidth: (contentWidth * width) / widthSum,
      halign: "center",
    };

    return styles;
  }, {});
};

const getReservoirPdfColumnStyles = (widths, contentWidth, id) => {
  const nameColumnIndex = id === "so5" || id === "so6" ? 0 : 1;

  if (!widths.length) {
    return { [nameColumnIndex]: { halign: "left", cellWidth: 38 } };
  }

  const widthSum = widths.reduce((sum, width) => sum + width, 0);

  return widths.reduce((styles, width, index) => {
    styles[index] = {
      cellWidth: Math.max(6, (contentWidth * width) / widthSum),
      halign: index === nameColumnIndex ? "left" : "center",
    };

    return styles;
  }, {});
};

const getReservoirPdfFontSize = (id) => {
  if (id === "so6") {
    return 3.5;
  }

  if (id === "so5") {
    return 6.3;
  }

  if (id === "so4") {
    return 5.2;
  }

  if (id === "so1" || id === "so3") {
    return 5.5;
  }

  return 6.4;
};

const styleRavotxojiPdfCell = (data) => {
  if (data.section === "head" && data.row.index > 0) {
    data.cell.styles.fillColor = PDF_HEADER_BLUE;
    data.cell.styles.textColor = [255, 255, 255];
    data.cell.styles.fontStyle = "bold";
    data.cell.styles.fontSize = 4.4;
    data.cell.styles.halign = "center";
    data.cell.styles.overflow = "visible";
  }

  if (data.section === "body" && data.row.index === data.table.body.length - 1) {
    data.cell.styles.fillColor = PDF_TOTAL_FILL;
    data.cell.styles.fontStyle = "bold";
    data.cell.styles.halign = "center";
  }
};

const styleReka02PdfCell = (data) => {
  const isAverageColumn = data.column.index === data.table.columns.length - 1;

  if (data.section === "head" && data.row.index > 0) {
    data.cell.styles.fillColor = PDF_HEADER_BLUE;
    data.cell.styles.textColor = [255, 255, 255];
    data.cell.styles.fontStyle = "bold";
    data.cell.styles.fontSize = 4.4;
    data.cell.styles.halign = "center";
    data.cell.styles.overflow = "visible";
  }

  if (data.section === "body" && isAverageColumn) {
    data.cell.styles.fillColor = PDF_TOTAL_FILL;
    data.cell.styles.fontStyle = "bold";
    data.cell.styles.halign = "center";
  }
};

const styleOqjarPdfCell = (data) => {
  if (data.section === "head" && data.row.index > 0) {
    data.cell.styles.fillColor = PDF_HEADER_BLUE;
    data.cell.styles.textColor = [255, 255, 255];
    data.cell.styles.fontStyle = "bold";
    data.cell.styles.halign = "center";
    data.cell.styles.valign = "middle";

    if (data.column.index === 3 || data.column.index === 4) {
      data.cell.styles.overflow = "visible";
      data.cell.styles.fontSize = 5;
      data.cell.styles.cellPadding = 0.45;
    }
  }
};

const getCleanCellText = (cell) => {
  return String(cell?.textContent || "")
    .replace(/\s+/g, " ")
    .trim();
};

const styleReservoirPdfCell = (data, id) => {
  const raw = data.cell.raw;
  const row = raw?.parentElement;
  const rowText = String(row?.textContent || "").trim().toLowerCase();
  const nameColumnIndex = id === "so5" || id === "so6" ? 0 : 1;
  const isDateRow = row?.classList?.contains("reservoir-excel-date-row");
  const isGroupRow = row?.classList?.contains("table-one-row");
  const isDividerRow = row?.classList?.contains("j-tr") && rowText === "shu jumladan";
  const isSummaryRow =
    row?.classList?.contains("j-tr") &&
    !row?.classList?.contains("table-one-row") &&
    !isDividerRow;

  if (data.section === "head" && data.row.index === 0) {
    data.cell.styles.fillColor = PDF_HEADER_DARK_BLUE;
    data.cell.styles.textColor = [255, 255, 255];
    data.cell.styles.fontStyle = "bold";
    data.cell.styles.fontSize = data.cell.styles.fontSize + 1;
  }

  if (isDateRow) {
    data.cell.styles.fillColor = [255, 255, 255];
    data.cell.styles.textColor = [0, 0, 0];
    data.cell.styles.fontStyle = "bold";
    data.cell.styles.halign = "right";
  }

  if (isGroupRow || isDividerRow) {
    data.cell.styles.fillColor = PDF_GROUP_FILL;
    data.cell.styles.textColor = [31, 78, 121];
    data.cell.styles.fontStyle = "bold";
    data.cell.styles.halign = "center";
  }

  if (isSummaryRow) {
    data.cell.styles.fillColor = PDF_TOTAL_FILL;
    data.cell.styles.fontStyle = "bold";
    data.cell.styles.halign = "center";
  }

  if (
    data.section === "body" &&
    data.column.index === nameColumnIndex &&
    !isGroupRow &&
    !isDividerRow &&
    !isSummaryRow
  ) {
    data.cell.styles.halign = "left";
  }
};
